module.exports = __webpack_public_path__ + "static/media/od_2.3bfe8736.jpg";